var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXFlowWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n  .st4{fill:#FFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M545.4,557.2h18.8v-23.5h23.3c0-6.4,0-10.4,0-16.6h-23.3v-15.8h26.3c0-6.2,0-10.5,0-16.6c-14.8,0-30.3,0-45.1,0 V557.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M630.8,484.7c-6.3,0-12.4,0-18.6,0v72.5h44.9c0-6.2,0-10.5,0-16.7h-26.3C630.8,509.7,630.8,522.2,630.8,484.7 L630.8,484.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M672.9,521.1c0,50.2,74.3,50.2,74.3,0C747.2,471,672.9,471,672.9,521.1z M691.9,521.1c0-26.1,36.3-26.1,36.3,0 C728.2,547.4,691.9,547.4,691.9,521.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M837.6,484.7l-9.2,27.3l-3.2,12.3h-0.3l-12.3-38.5c-2.9,0-5,0-7.9,0l-12.1,38.5h-0.3l-3.2-12.3l-9.3-27.3h-18.7 v2.8l25.5,70.4h10.2l11.6-34.9h0.3l11.6,34.9H831l25.2-70.4v-2.8L837.6,484.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215,589h-2c-6.1,0-11,4.9-11,11s4.9,11,11,11h2c6.1,0,11-4.9,11-11S221.1,589,215,589z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203,493h6c6.1,0,11-4.9,11-11s-4.9-11-11-11h-6c-6.1,0-11,4.9-11,11S196.9,493,203,493z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M452.5,451.3c-7.6,10.7-15.6,21.3-24.2,31.5c-18.4-20.6-38.5-40.6-60.4-60c-22,3.1-41.7,13.5-56.6,28.6 c30.1,21.9,57.6,45.1,82.1,69.6c-24.5,24.5-52,47.7-82.1,69.7c14.9,15.1,34.6,25.5,56.6,28.6c21.9-19.4,42.1-39.3,60.4-60 c8.5,10.3,16.6,20.8,24.2,31.5c11.9-12,20.8-27.1,25.3-44c-5.8-8.7-11.8-17.3-18.2-25.8c6.4-8.5,12.4-17.1,18.2-25.8 C473.3,478.4,464.5,463.3,452.5,451.3L452.5,451.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382,393H277c-6.1,0-11,4.9-11,11s4.9,11,11,11h33.2c-7.3,5-14.1,10.7-20.2,17h-69c-6.1,0-11,4.9-11,11 s4.9,11,11,11h51.9c-3.3,5.4-6.3,11.1-8.8,17H245c-6.1,0-11,4.9-11,11s4.9,11,11,11h12.1c-1.2,5.5-2.1,11.2-2.6,17H179 c-6.1,0-11,4.9-11,11s4.9,11,11,11h75.5c0.5,5.8,1.4,11.5,2.6,17H213c-6.1,0-11,4.9-11,11s4.9,11,11,11h51.1 c2.5,5.9,5.5,11.6,8.8,17H249c-6.1,0-11,4.9-11,11s4.9,11,11,11h41.1c6.1,6.3,12.9,12,20.2,17H277c-6.1,0-11,4.9-11,11s4.9,11,11,11 h105c70.7,0,128-57.3,128-128S452.7,393,382,393L382,393z M382,631c-60.8,0-110-49.2-110-110s49.2-110,110-110s110,49.2,110,110 S442.8,631,382,631z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXFlowWhiteLogo);
export default __webpack_public_path__ + "static/media/x_flow_white_logo.4729a394635521710906aeb3c8f44fcc.svg";
export { ForwardRef as ReactComponent };